<template>
  <div>
    <div class="circle">
      <div class="triangle-block">
        <div class="triangle"></div>
      </div>
    </div>
    <h2>Your response has been submitted. Thank you for your participation.</h2>
  </div>
</template>
<script>
export default {};
</script>
<style lang="scss" scoped>
h2 {
  color: #545454;
  font-size: 20px;
  line-height: 1;
  font-weight: normal;
  text-align: center;
  margin-top: 0;
}
.circle {
  width: 87px;
  height: 87px;
  background: #94c959;
  border-radius: 50%;
  margin: 150px auto 70px;
  .triangle-block {
    height: 87px;
    display: table-cell;
    vertical-align: middle;
    .triangle {
      width: 44px;
      height: 23px;
      border: 7px solid #fff;
      box-sizing: border-box;
      border-top: none;
      border-right: none;
      margin-left: 22px;
      margin-top: -3px;
      -webkit-transform: rotate(-45deg);
      transform: rotate(-45deg);
    }
  }
}
</style>
